import { useEscapeStack } from "../hooks/useEscapeStack";

type Props = {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmDialog({
  open,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  busy = false,
  onConfirm,
  onCancel
}: Props) {
  useEscapeStack(open && !busy, onCancel);

  if (!open) return null;

  return (
    <div className="modal-backdrop" style={{ zIndex: 2600 }}>
      <div className="modal" style={{ maxWidth: 460 }}>
        <h3 className="section-title" style={{ marginTop: 0 }}>
          {title}
        </h3>
        <p style={{ color: "var(--text-primary)", marginTop: 8 }}>{message}</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
          <button className="button secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button className="button" onClick={onConfirm} disabled={busy}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
